import Noun from '../core/Noun';

class MetaOption extends Noun {
  constructor(args = {}) {
    super(args);
  }

  id() {
    return this.attr('id');
  }

  // merge() handled automatically
}

export default MetaOption;
